import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      nav(u.role === "admin" ? "/admin" : "/account");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="container-x py-16 max-w-md" data-testid="login-page">
      <h1 className="font-serif text-4xl mb-2">Welcome back</h1>
      <p className="text-sm text-muted-foreground mb-8">Sign in to your AdiYogi account</p>
      <form onSubmit={submit} className="space-y-4">
        <label className="block">
          <div className="text-xs text-muted-foreground mb-1">Email</div>
          <input data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" className="w-full border hairline rounded-lg px-3 py-2 bg-white outline-none focus:border-[#B8860B]" required />
        </label>
        <label className="block">
          <div className="text-xs text-muted-foreground mb-1">Password</div>
          <input data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} type="password" className="w-full border hairline rounded-lg px-3 py-2 bg-white outline-none focus:border-[#B8860B]" required />
        </label>
        <button disabled={loading} className="w-full btn-gold rounded-full py-3 text-xs uppercase tracking-widest" data-testid="login-submit">{loading ? "Signing in…" : "Sign In"}</button>
      </form>
      <div className="my-6 flex items-center gap-3 text-xs text-muted-foreground"><div className="flex-1 border-t hairline"></div>OR<div className="flex-1 border-t hairline"></div></div>
      <button onClick={googleLogin} className="w-full border hairline rounded-full py-3 text-sm hover:bg-muted transition" data-testid="google-login-btn">Continue with Google</button>
      <div className="mt-6 text-sm text-center text-muted-foreground">
        Don't have an account? <Link to="/register" className="gold-text">Create one</Link>
      </div>
    </div>
  );
}
